import { toast } from 'sonner';

import { useCreateJobNoteMutation } from '@/modules/jobs/mutations/useCreateJobNoteMutation';
import { useJobNotesQuery } from '@/modules/jobs/queries/useJobNotesQuery';
import type {
  JobNoteType,
  NoteFormData,
} from '@/modules/notes/components/NoteForm';
import { NotesList } from '@/modules/notes/components/NotesList';
import { extractErrorMessage } from '@/utils/extractErrorMessage';

import { JobNoteCard } from './JobNoteCard';

export const jobNoteTypeOptions: { value: JobNoteType; label: string }[] = [
  { value: 'General', label: 'General' },
  { value: 'Intake', label: 'Intake' },
];

interface JobNotesListProps {
  jobId: string;
}

export const JobNotesList = ({ jobId }: JobNotesListProps) => {
  const { data: notes, isLoading } = useJobNotesQuery(jobId);
  const createNoteMutation = useCreateJobNoteMutation();

  const handleAddNote = (data: NoteFormData) => {
    createNoteMutation.mutate(
      {
        jobId,
        body: {
          content: data.content,
          type: data.type as JobNoteType,
        },
      },
      {
        onSuccess: () => {
          toast.success('Note added successfully');
        },
        onError: (error) => {
          toast.error(`Failed to add note: ${extractErrorMessage(error)}`);
        },
      },
    );
  };

  return (
    <NotesList
      notes={notes}
      isLoading={isLoading}
      onAddNote={handleAddNote}
      isCreating={createNoteMutation.isPending}
      title="Notes"
      description="Keep track of important information about this job"
      typeOptions={jobNoteTypeOptions}
      renderNoteCard={(note) => <JobNoteCard note={note} jobId={jobId} />}
    />
  );
};
